import type { GalleryDataAdapter, EventData, Photo, PhotoComment, ScavengerHuntCard, ScavengerHuntData, ScavengerHuntItem, UploadResult, VoiceMessageRecord } from "@/components/gallery/types";

/* ─── Demo data ─── */

const DEMO_PHOTOS: Photo[] = [
  { id: "demo-1", file_url: "https://www.fionakellyphotography.com/wp-content/uploads/2022/02/wedding-first-dance-wedding-traditions_0016.jpg", file_path: "first-dance.jpg", created_at: "2026-03-29T10:00:00Z", uploaded_by: "demo-user-1", media_type: "image" },
  { id: "demo-20", file_url: "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80", file_path: "demo/20.jpg", created_at: "2026-03-29T10:00:00Z", uploaded_by: "demo-user-12", media_type: "image" },
  { id: "demo-me-1", file_url: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&q=80", file_path: "demo/me-1.jpg", created_at: "2026-03-29T09:45:00Z", uploaded_by: "demo-device", media_type: "image" },
  { id: "demo-2", file_url: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80", file_path: "demo/2.jpg", created_at: "2026-03-29T09:30:00Z", uploaded_by: "demo-user-2", media_type: "image" },
  { id: "demo-3", file_url: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80", file_path: "demo/3.jpg", created_at: "2026-03-29T09:00:00Z", uploaded_by: "demo-user-1", media_type: "image" },
  { id: "demo-4", file_url: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80", file_path: "demo/4.jpg", created_at: "2026-03-29T08:30:00Z", uploaded_by: "demo-user-3", media_type: "image" },
  { id: "demo-5", file_url: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=600&q=80", file_path: "demo/5.jpg", created_at: "2026-03-29T08:00:00Z", uploaded_by: "demo-user-2", media_type: "image" },
  { id: "demo-me-2", file_url: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=600&q=80", file_path: "demo/me-2.jpg", created_at: "2026-03-29T07:45:00Z", uploaded_by: "demo-device", media_type: "image" },
  { id: "demo-6", file_url: "https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=600&q=80", file_path: "demo/6.jpg", created_at: "2026-03-29T07:30:00Z", uploaded_by: "demo-user-4", media_type: "image" },
  { id: "demo-7", file_url: "https://images.unsplash.com/photo-1470290378698-263fa7ca60ab?w=600&q=80", file_path: "demo/7.jpg", created_at: "2026-03-29T07:00:00Z", uploaded_by: "demo-user-1", media_type: "image" },
  { id: "demo-8", file_url: "https://images.unsplash.com/photo-1532712938310-34cb3982ef74?w=600&q=80", file_path: "demo/8.jpg", created_at: "2026-03-29T06:30:00Z", uploaded_by: "demo-user-3", media_type: "image" },
  { id: "demo-me-3", file_url: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&q=80", file_path: "demo/me-3.jpg", created_at: "2026-03-29T06:15:00Z", uploaded_by: "demo-device", media_type: "image" },
  { id: "demo-9", file_url: "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=600&q=80", file_path: "demo/9.jpg", created_at: "2026-03-29T06:00:00Z", uploaded_by: "demo-user-2", media_type: "image" },
  { id: "demo-10", file_url: "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&q=80", file_path: "demo/10.jpg", created_at: "2026-03-29T05:30:00Z", uploaded_by: "demo-user-4", media_type: "image" },
  { id: "demo-11", file_url: "https://images.unsplash.com/photo-1544078751-58fee2d8a03b?w=600&q=80", file_path: "demo/11.jpg", created_at: "2026-03-29T05:00:00Z", uploaded_by: "demo-user-1", media_type: "image" },
  { id: "demo-12", file_url: "https://images.unsplash.com/photo-1507504031003-b417219a0fde?w=600&q=80", file_path: "demo/12.jpg", created_at: "2026-03-29T04:30:00Z", uploaded_by: "demo-user-3", media_type: "image" },
  { id: "demo-13", file_url: "https://images.unsplash.com/photo-1460978812857-470ed1c77af0?w=600&q=80", file_path: "demo/13.jpg", created_at: "2026-03-29T04:00:00Z", uploaded_by: "demo-user-2", media_type: "image" },
  { id: "demo-14", file_url: "https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=600&q=80", file_path: "demo/14.jpg", created_at: "2026-03-29T03:30:00Z", uploaded_by: "demo-user-4", media_type: "image" },
  { id: "demo-15", file_url: "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9?w=600&q=80", file_path: "demo/15.jpg", created_at: "2026-03-29T03:00:00Z", uploaded_by: "demo-user-1", media_type: "image" },
  { id: "demo-16", file_url: "https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=600&q=80", file_path: "demo/16.jpg", created_at: "2026-03-29T02:30:00Z", uploaded_by: "demo-user-2", media_type: "image" },
  { id: "demo-17", file_url: "https://images.unsplash.com/photo-1505932794465-147d1f1b2c97?w=600&q=80", file_path: "demo/17.jpg", created_at: "2026-03-29T02:00:00Z", uploaded_by: "demo-user-3", media_type: "image" },
  { id: "demo-18", file_url: "https://images.unsplash.com/photo-1529636798458-92182e662485?w=600&q=80", file_path: "demo/18.jpg", created_at: "2026-03-29T01:30:00Z", uploaded_by: "demo-user-4", media_type: "image" },
  { id: "demo-19", file_url: "https://images.unsplash.com/photo-1529636798458-92182e662485?w=600&q=80", file_path: "demo/19.jpg", created_at: "2026-03-29T01:30:00Z", uploaded_by: "demo-user-4", media_type: "image" },
];

const DEMO_EVENT: EventData = {
  id: "demo-event",
  slug: "demo",
  title: "Ana & Marco",
  subtitle: "Slavimo ljubav",
  event_date: "2026-06-15",
  primary_color: null,
  hero_image_url: null,
  logo_url: null,
  custom_message: null,
  is_active: true,
  social_enabled: true,
  uploads_locked: false,
  onboarding_complete: true,
};

const DEMO_GUEST_NAMES: Record<string, string | null> = {
  "demo-user-1": "Ana",
  "demo-user-2": "Marko",
  "demo-user-3": "Ivana",
  "demo-user-4": "Luka",
  "demo-device": null,
};

const DEMO_VOICE_MESSAGES: VoiceMessageRecord[] = [
  {
    id: "voice-demo-1",
    event_id: "demo-event",
    uploaded_by: "demo-user-2",
    guest_name: "Marko",
    file_path: "demo/voice1.webm",
    file_url: "",
    duration_seconds: 15,
    created_at: "2026-03-29T09:00:00Z",
  },
];

/* ─── Demo comment counts ─── */
const DEMO_PHOTO_COMMENTS: Record<string, PhotoComment[]> = {
  "demo-1": [
    {
      id: "demo-comment-1",
      photo_id: "demo-1",
      device_code: "demo-user-2",
      guest_name: "Marko",
      content: "This photo feels exactly like the dance floor did.",
      content_key: "app.demo.comments.demo1.root1",
      parent_id: null,
      created_at: "2026-03-29T10:05:00Z",
    },
    {
      id: "demo-comment-2",
      photo_id: "demo-1",
      device_code: "demo-user-3",
      guest_name: "Ivana",
      content: "And this was before the real dancing even started.",
      content_key: "app.demo.comments.demo1.reply1",
      parent_id: "demo-comment-1",
      created_at: "2026-03-29T10:07:00Z",
    },
    {
      id: "demo-comment-3",
      photo_id: "demo-1",
      device_code: "demo-user-4",
      guest_name: "Luka",
      content: "Best warm-up of the night.",
      content_key: "app.demo.comments.demo1.reply2",
      parent_id: "demo-comment-1",
      created_at: "2026-03-29T10:09:00Z",
    },
    {
      id: "demo-comment-4",
      photo_id: "demo-1",
      device_code: "demo-device",
      guest_name: null,
      content: "Saving this one for the thank-you cards.",
      content_key: "app.demo.comments.demo1.root2",
      parent_id: null,
      created_at: "2026-03-29T10:12:00Z",
    },
  ],
};

const DEMO_COMMENT_COUNTS: Record<string, number> = {
  "demo-1": DEMO_PHOTO_COMMENTS["demo-1"].length,
  "demo-2": 7,
  "demo-3": 1,
  "demo-5": 4,
  "demo-7": 2,
  "demo-9": 5,
  "demo-12": 1,
  "demo-14": 3,
};

const demoLikes: Record<string, number> = { "demo-1": 5, "demo-me-1": 6, "demo-2": 12, "demo-3": 3, "demo-5": 8, "demo-me-2": 4, "demo-7": 15, "demo-me-3": 2, "demo-9": 7, "demo-10": 4, "demo-14": 9 };
const demoMyLikes = new Set(["demo-2", "demo-7"]);
const DEMO_HUNT: ScavengerHuntData = {
  huntId: "demo-hunt",
  templateId: "demo-template",
  items: [
    { id: "demo-hunt-1", label: "With the newlyweds", order: 0 },
    { id: "demo-hunt-2", label: "Something blue", order: 1 },
    { id: "demo-hunt-3", label: "Best dance move", order: 2 },
  ],
};
const demoHuntTags: Array<{ photoId: string; itemId: string; deviceCode: string }> = [
  { photoId: "demo-me-1", itemId: "demo-hunt-1", deviceCode: "demo-device" },
  { photoId: "demo-1", itemId: "demo-hunt-1", deviceCode: "demo-user-2" },
  { photoId: "demo-7", itemId: "demo-hunt-1", deviceCode: "demo-user-1" },
  { photoId: "demo-me-2", itemId: "demo-hunt-2", deviceCode: "demo-device" },
  { photoId: "demo-5", itemId: "demo-hunt-2", deviceCode: "demo-user-3" },
  { photoId: "demo-3", itemId: "demo-hunt-3", deviceCode: "demo-user-1" },
  { photoId: "demo-9", itemId: "demo-hunt-3", deviceCode: "demo-user-2" },
];

function withDemoComments(photo: Photo): Photo {
  return {
    ...photo,
    demoComments: DEMO_PHOTO_COMMENTS[photo.id] ?? [],
  };
}

export function createDemoAdapter(overrides?: {
  event?: Partial<EventData>;
  photos?: Photo[];
  featureFlags?: { socialEnabled?: boolean; voiceEnabled?: boolean; zipEnabled?: boolean };
  guestNames?: Record<string, string | null>;
}): GalleryDataAdapter {
  const event = { ...DEMO_EVENT, ...overrides?.event };
  const photos = overrides?.photos ?? DEMO_PHOTOS.map(withDemoComments);
  const guestNames = { ...DEMO_GUEST_NAMES, ...overrides?.guestNames };

  return {
    async fetchEvent(_slug?: string, _token?: string | null) {
      return event;
    },

    async verifyPin(_eventId: string, _pin: string) {
      return true;
    },

    async getOrCreateDeviceCode() {
      return "demo-device";
    },

    async fetchGuestName(deviceCode) {
      return guestNames[deviceCode] ?? null;
    },

    async updateGuestName(deviceCode, name) {
      guestNames[deviceCode] = name;
    },

    async checkAddon(_eventId, addonType) {
      if (addonType === "zip_download") return overrides?.featureFlags?.zipEnabled ?? false;
      if (addonType === "voice_guestbook") return overrides?.featureFlags?.voiceEnabled ?? true;
      if (addonType === "video_upload") return true;
      return false;
    },

    async checkEventAdmin() {
      return false;
    },

    async countApprovedPhotos() {
      return photos.length;
    },

    async fetchApprovedPhotos(_eventId, opts) {
      const limit = opts?.limit ?? 1000;
      const offset = opts?.offset ?? 0;
      return photos.slice(offset, offset + limit);
    },

    async countAllPhotos() {
      return photos.length;
    },

    async fetchAllPhotos() {
      return photos.map((photo) => ({ ...photo, approved: true }));
    },

    async fetchPhotoIdsByUploader(deviceCode) {
      return photos.filter((p) => p.uploaded_by === deviceCode).map((p) => p.id);
    },

    async uploadPhoto(_file, _slug, _eventId, deviceCode, _caption): Promise<UploadResult | null> {
      const id = `demo-upload-${Date.now()}`;
      const newPhoto: Photo = {
        id,
        file_url: URL.createObjectURL(_file),
        file_path: `demo/${id}.jpg`,
        created_at: new Date().toISOString(),
        uploaded_by: deviceCode,
        media_type: _file.type.startsWith("video/") ? "video" : "image",
        demoComments: [],
      };
      photos.unshift(newPhoto);
      return { id, file_url: newPhoto.file_url, file_path: newPhoto.file_path, media_type: newPhoto.media_type! };
    },

    async updatePhotoCaption(photoId, caption) {
      const photo = photos.find((entry) => entry.id === photoId);
      if (photo) {
        photo.caption = caption;
      }
    },

    async deletePhoto(photoId) {
      const idx = photos.findIndex((p) => p.id === photoId);
      if (idx !== -1) photos.splice(idx, 1);
    },

    async approvePhoto() {
      return;
    },

    async unapprovePhoto() {
      return;
    },

    async fetchLikes(photoIds, deviceCode) {
      const counts: Record<string, number> = {};
      const myLikes: string[] = [];
      photoIds.forEach((id) => {
        if (demoLikes[id]) counts[id] = demoLikes[id];
        if (demoMyLikes.has(id)) myLikes.push(id);
      });
      return { counts, myLikes };
    },

    async toggleLike(photoId, _deviceCode, currentlyLiked) {
      if (currentlyLiked) {
        demoMyLikes.delete(photoId);
        demoLikes[photoId] = Math.max(0, (demoLikes[photoId] || 0) - 1);
      } else {
        demoMyLikes.add(photoId);
        demoLikes[photoId] = (demoLikes[photoId] || 0) + 1;
      }
    },

    async fetchCommentCounts(photoIds: string[]) {
      const counts: Record<string, number> = {};
      photoIds.forEach((id) => {
        if (DEMO_COMMENT_COUNTS[id]) counts[id] = DEMO_COMMENT_COUNTS[id];
      });
      return counts;
    },

    async fetchGuestNames() {
      return { ...guestNames };
    },

    async fetchVoiceMessages() {
      return [...DEMO_VOICE_MESSAGES];
    },

    async uploadVoiceMessage(params) {
      const msg: VoiceMessageRecord = {
        id: `voice-demo-${Date.now()}`,
        event_id: "demo-event",
        uploaded_by: params.deviceCode,
        guest_name: params.guestName || null,
        file_path: `demo/voice-${Date.now()}.webm`,
        file_url: URL.createObjectURL(params.audioFile),
        duration_seconds: params.durationSeconds ?? null,
        created_at: new Date().toISOString(),
      };
      DEMO_VOICE_MESSAGES.unshift(msg);
      return msg;
    },

    async deleteVoiceMessage(id) {
      const idx = DEMO_VOICE_MESSAGES.findIndex((m) => m.id === id);
      if (idx !== -1) DEMO_VOICE_MESSAGES.splice(idx, 1);
    },

    async fetchScavengerHunt() {
      return DEMO_HUNT;
    },

    async fetchScavengerHuntCards(_eventId, _huntId, deviceCode) {
      return DEMO_HUNT.items.map((item) => {
        const itemTags = demoHuntTags.filter((tag) => tag.itemId === item.id);
        const myTag = itemTags.find((tag) => tag.deviceCode === deviceCode);
        const previewPhotos = itemTags
          .map((tag) => photos.find((photo) => photo.id === tag.photoId))
          .filter((photo): photo is Photo => !!photo)
          .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
          .slice(0, 4);
        return {
          item,
          myPhoto: photos.find((photo) => photo.id === myTag?.photoId) ?? null,
          totalCount: itemTags.length,
          previewPhotos,
        } satisfies ScavengerHuntCard;
      });
    },

    async fetchScavengerCategoryPhotos(_params) {
      return demoHuntTags
        .filter((tag) => tag.itemId === _params.itemId)
        .map((tag) => photos.find((photo) => photo.id === tag.photoId))
        .filter((photo): photo is Photo => !!photo)
        .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    },

    async replaceScavengerHuntPhoto({ photoId, itemId, deviceCode }) {
      const existingIndex = demoHuntTags.findIndex((tag) => tag.itemId === itemId && tag.deviceCode === deviceCode);
      let replacedPhotoId: string | null = null;
      if (existingIndex >= 0) {
        replacedPhotoId = demoHuntTags[existingIndex].photoId;
        demoHuntTags.splice(existingIndex, 1);
      }
      demoHuntTags.push({ photoId, itemId, deviceCode });
      if (replacedPhotoId) {
        const photoIndex = photos.findIndex((photo) => photo.id === replacedPhotoId);
        if (photoIndex >= 0) photos.splice(photoIndex, 1);
      }
      return { replacedPhotoId };
    },

    async tagPhotoForHunt({ photoId, itemId, deviceCode }) {
      demoHuntTags.push({ photoId, itemId, deviceCode });
    },

    async fetchScavengerTagCounts(_eventId, _huntId) {
      const counts: Record<string, number> = {};
      demoHuntTags.forEach((tag) => {
        counts[tag.itemId] = (counts[tag.itemId] ?? 0) + 1;
      });
      return counts;
    },

    subscribePhotos() {
      return () => {};
    },

    subscribeVoice() {
      return () => {};
    },
  };
}

export { DEMO_COMMENT_COUNTS };
